<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xml:space="preserve"
    width="128px"
    height="128px"
    version="1.1"
    style="
      shape-rendering: geometricPrecision;
      text-rendering: geometricPrecision;
      image-rendering: optimizeQuality;
      fill-rule: evenodd;
      clip-rule: evenodd;
    "
    viewBox="0 0 128 128"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    xmlns:xodm="http://www.corel.com/coreldraw/odm/2003"
  >
    <defs>
      <!-- <style type="text/css">
        <![CDATA[
         .fil0 {fill:black}
        ]]>
      </style> -->
    </defs>
    <g id="Layer_x0020_2">
      <metadata id="CorelCorpID_0Corel-Layer" />
      <path
        class="fil0"
        d="M20.91 49.54l0 47.77 21.86 0 -4.07 6.46 -17.79 0 -6.81 0 -1.83 0 0 -6.46 1.83 0 0 -43 -5.18 3.63 -8.92 -13.15 22.72 -15.9 0 -20.62 19.34 0 0 7.09 21.94 -15.36 64 44.79 -8.81 12.95 -6.19 -4.07 0 36.17 -6.82 -8.1 0 -32.84 -42.18 -29.52 -43.09 30.16zm24.72 54.18l27.02 2.93c-0.72,-7.47 -0.58,-15.34 -0.43,-22.85 3.14,0.48 6.28,5.08 9.42,5.08 3.31,0 6.61,-5.12 9.92,-5.12 0.63,0 1.25,0.03 1.86,0.1 -0.78,6.37 -1.31,13.58 -1.56,20.69 -0.24,6.76 -0.08,17.7 0.22,23.45l-0.06 0c-10.41,0 -20.6,-0.16 -31.06,0l2.48 -3.32 13.82 0 -5.56 -15.38 -21.7 -2.26 -2.82 3.02 -1.55 -6.34zm17.19 -39.04l-0.2 -0.17c0.75,-0.42 1.93,-1.43 2.71,-2.04 4.14,-3.23 3.53,-1.94 3.88,-5.46 0.4,-4.19 0.08,-6.88 4.85,-9.3 2.61,-1.31 4.51,-1.45 7.71,-1.51 0.45,-0.45 0.86,-1.01 1.94,-0.86 1.15,0.16 1.13,0.76 1.6,1.08 1.16,0.78 12.26,0.37 11.8,14.94 -0.12,3.71 -2.11,4.42 -5.07,5.53 -1.54,0.58 -2.67,0.68 -3.61,1.86 -2.5,3.16 -7.11,5.04 -11.36,3.05 -5.65,-2.65 -6.46,-7.01 -14.25,-7.12zm33.26 1.44l0 0.05c0,7.44 -5.98,13.47 -13.36,13.47 -6.62,0 -12.12,-4.86 -13.17,-11.24 -0.04,0.01 -0.01,0.07 -0.04,0.26l-0.15 -0.46 0.16 0c-0.03,-0.17 -0.05,-0.34 -0.07,-0.51 2.19,1.48 3.85,3.54 7.16,5.09 4.47,2.1 9.66,0.44 12.66,-3.35 0.73,-0.92 2.09,-1.12 3.14,-1.52 1.48,-0.56 2.72,-1.06 3.67,-1.79zm-42.25 35.31l0.03 -0.13c2,-8.8 6.86,-15.62 14.41,-17.2 -0.12,6.57 -0.1,12.91 0.11,18.91l-14.55 -1.58zm43.46 -16.68c6.74,2.41 11.6,8.93 11.6,16.53l0 26.72 -12.98 0c-0.32,-5.8 -0.35,-16.46 -0.11,-23.31 0.24,-6.83 0.75,-13.77 1.49,-19.94zm-10.27 12.27l2.25 0.07c0.41,0.02 0.72,0.36 0.71,0.77l-0.08 2.49c-0.01,0.41 -0.35,0.73 -0.76,0.72l-2.25 -0.07 -0.08 2.28c-0.01,0.41 -0.35,0.73 -0.75,0.71l-2.47 -0.08c-0.41,-0.01 -0.72,-0.36 -0.71,-0.76l0.07 -2.28 -2.25 -0.08c-0.41,-0.01 -0.72,-0.35 -0.71,-0.76l0.08 -2.5c0.01,-0.41 0.35,-0.73 0.76,-0.72l2.25 0.08 0.08 -2.28c0.01,-0.41 0.35,-0.73 0.75,-0.72l2.47 0.08c0.4,0.02 0.72,0.36 0.71,0.77l-0.07 2.28zm-38.08 15.14l4.78 0c3.59,0 6.53,2.97 6.53,6.6l0 2.05c0,3.64 -2.94,6.61 -6.53,6.61 -1.09,0 -2.18,0 -3.27,0 -2.44,-3.94 -3.95,-8.27 -3.27,-13.48 0.13,-0.97 0.79,-1.78 1.76,-1.78zm-15.11 -63.44l19.53 0 0 19.75 -19.53 0 0 -19.75z"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'IconVisitasDomiciliares',
}
</script>

<style></style>
